export interface LeadFunnel {
  id: number;
  name: string;
  description: string | null;
  position: number;
  isDefault: boolean;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface LeadStatusConfig {
  id: number;
  leadFunnelId: number;
  name: string;
  color: string;
  description: string | null;
  position: number;
  isInitial: boolean;
  isFinal: boolean;
  isSystem: boolean;
  onEnterActions: LeadStatusAction[];
  onExitActions: LeadStatusAction[];
  createdAt: string;
  updatedAt: string;
}

export type LeadStatusAction =
  | { type: 'send_notification'; templateId: number }
  | { type: 'assign_tag'; tagId: number }
  | { type: 'remove_tag'; tagId: number }
  | {
    type: 'webhook';
    url: string;
    method: 'GET' | 'POST';
    headers?: Record<string, string>;
  };

export interface LeadUser {
  id: number;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  username?: string | null;
  telegramId?: string | null;
}

export interface LeadAdmin {
  id: number;
  username: string;
}

export interface LeadTagInfo {
  id: number;
  name: string;
  color: string;
}

export interface LeadTagItem {
  id: number;
  leadId: number;
  tagId: number;
  source: string;
  tag: LeadTagInfo;
}

export interface Lead {
  id: number;
  email: string | null;
  phone: string | null;
  telegramUsername: string | null;
  firstName: string | null;
  lastName: string | null;
  statusConfig: LeadStatusConfig | null;
  statusConfigId: number;
  user: LeadUser | null;
  assignedAdmin: LeadAdmin | null;
  assignedAdminId: number | null;
  tags: LeadTagItem[];
  customData: Record<string, unknown> | null;
  metadata: Record<string, unknown> | null;
  convertedUserId: number | null;
  convertedAt: string | null;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface LeadNote {
  id: number;
  leadId: number;
  adminUserId: number;
  content: string;
  createdAt: string;
  updatedAt: string;
  adminUser?: {
    id: number;
    username: string;
  } | null;
}

export interface LeadWebhook {
  id: number;
  name: string;
  fieldMapping: Record<string, string> | null;
  defaultTagIds: number[];
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface LeadWebhookWithFields extends LeadWebhook {
  customFields: LeadCustomField[];
}

export interface LeadCustomField {
  id: number;
  leadWebhookId: number;
  name: string;
  label: string | null;
  fieldType: string | null;
  isRequired: boolean;
  position: number;
}

export interface AdminUser {
  id: number;
  username: string;
  email: string;
}

export function getLeadDisplayName(lead: Pick<Lead, 'firstName' | 'lastName' | 'email' | 'phone' | 'telegramUsername' | 'id'>): string {
  const nameParts = [lead.firstName, lead.lastName].filter(Boolean);
  if (nameParts.length > 0) {
    return nameParts.join(' ');
  }
  if (lead.email) {
    return lead.email;
  }
  if (lead.telegramUsername) {
    return `@${lead.telegramUsername}`;
  }
  if (lead.phone) {
    return lead.phone;
  }
  return `Лид #${lead.id}`;
}
